export default __webpack_public_path__ + "static/media/olivine24.78ad21c9.png";